<!--
 * @Description:
 * @Version: 2.0
 * @Autor: dudedu
 * @Date: 2022-10-10 15:04:00
 * @LastEditors: dudedu
 * @LastEditTime: 2023-01-13 11:06:21
-->
<template>
  <div>
    <statistics v-if="projectListLength === 0" @click="addTeam"></statistics>
    <introduction v-else></introduction>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import statistics from './components/statistics';
import introduction from './components/introduction';
export default {
  name: 'dashboard',
  data() {
    return {
      projectListLength: 0,
    };
  },
  components: {
    statistics,
    introduction,
  },
  computed: {
    ...mapState(['app']),
  },
  watch: {
    'app.projectList'(val) {
      this.projectListLength = val.length;
    },
  },
  created() {
    this.projectListLength = this.app.projectList.length;
  },
  methods: {
    addTeam() {
      this.$emit('click', 'apply');
    },
  },
  beforeDestroy() {
    this.$off('click');
  },
};
</script>

<style scoped lang="scss">
.dashboard {
  background: #FFFFFF;
  padding: 10px 25px 25px;
  min-width: 994px;

  ::v-deep .el-dialog__header {
    padding-bottom: 20px;
    color: rgba(0,0,0,1);
    font-weight: 400;
    font-family: "PingFang SC";
    span {
      font-size: 16px;
    }
  }
  ::v-deep .el-dialog__body {
    padding-top: 10px;
    color: rgba(0,0,0,1);
    font-weight: 400;
    font-size: 16px;
    font-family: "PingFang SC";
  }
}
.content {
  padding:50px 25px 0;
  display: flex;
  justify-content: space-between;
}
.el-button {
  width: 112px;
  height: 40px;
  padding: 0;
}
.btn_group {
  padding-top: 22px;
  text-align: center;
}
.content_item {
  width: 30%;
  font-size: 12px;
  img {
    width: 100%;
  }
  p {
    text-align: center;
    font-size: 14px;
  }
  span :last-child {
    color: rgba(0,82,217,1);
    cursor: pointer;
  }
}
</style>
